document.addEventListener('DOMContentLoaded', (event) => {

  function dispatchRoamAddonsUpdated() {
    const selectedAddons = document.querySelectorAll('.quick-add-product.active-product');
    window.dispatchEvent(new CustomEvent('roam-addons-updated', {
      detail: {
        count: selectedAddons.length
      }
    }));
  }

  window.dispatchRoamAddonsUpdated = dispatchRoamAddonsUpdated;

  document.querySelectorAll('.quick-add-product').forEach(function(product) {
    // Event listener for opening the details panel / selecting the add-on
    product.addEventListener('click', function(e) {
      let clickTarget = e.target;
      if (clickTarget.closest && clickTarget.closest('.add-on-product-title-element')) {
        let link = clickTarget.closest('.add-on-product-title-element').querySelector('a');
        if (link && link.href) {
          window.location.href = link.href;
        } else {
          console.log("No link found");
        }
      } else {
        if (product.classList.contains('closed-product')) {
          // Open the details panel and mark the add-on as selected
          var details = product.querySelector('.quick-add-details');
          if (details) details.style.display = "flex";
          product.classList.add('active-product');
          product.classList.remove('closed-product');
          dispatchRoamAddonsUpdated();
        }
      }
    });
  
    // Event listener for the image and checkbox to close the panel / deselect the add-on
    product.querySelectorAll('.quick-add-image, .quick-add-checkbox').forEach(function(element) {
      element.addEventListener('click', function(e) {
        if (product.classList.contains('active-product')) {
          // Prevent the event from bubbling up to the product and reopening it
          e.stopPropagation();
          e.preventDefault();
  
          // Close the details panel and mark the add-on as deselected
          var details = product.querySelector('.quick-add-details');
          if (details) details.style.display = "none";
          product.classList.remove('active-product');
          product.classList.add('closed-product');
          dispatchRoamAddonsUpdated();
        }
      });
    });
  });

  dispatchRoamAddonsUpdated();
});

document.addEventListener('DOMContentLoaded', function() {
  // Function to update quantity
  function updateQuantity(input, increment) {
    var currentVal = parseInt(input.value, 10);
    var max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : Infinity;
    var newVal = currentVal + increment;

    // Check the new value is within the allowed range
    if (newVal >= 1 && newVal <= max) {
      input.value = newVal;
    }
  }

  // Handle click events on the increase and decrease buttons
  document.querySelectorAll('.quick-add-quantity-selector').forEach(function(selector) {
    var decreaseButton = selector.querySelector('.quantity-decrease');
    var increaseButton = selector.querySelector('.quantity-increase');
    var quantityInput = selector.querySelector('.js-quantity-input');

    if (decreaseButton && quantityInput) {
      decreaseButton.addEventListener('click', function(e) {
        e.stopPropagation();
        updateQuantity(quantityInput, -1);
      });
    }

    if (increaseButton && quantityInput) {
      increaseButton.addEventListener('click', function(e) {
        e.stopPropagation();
        updateQuantity(quantityInput, 1);
      });
    }
  });

  document.addEventListener('click', function (event) {
    // Check if a variant button was clicked
    if (event.target.matches('.quick-add-variant-button')) {
      event.preventDefault();
      event.stopPropagation();
      // Get all sibling buttons
      var siblings = event.target.parentNode.querySelectorAll('.quick-add-variant-button');
      // Remove the active class from all sibling buttons
      siblings.forEach(function (sibling) {
        sibling.classList.remove('active');
      });
      // Add the active class to the clicked button
      event.target.classList.add('active');
      var variantPrice = event.target.getAttribute('data-variant-price');
      var collapsedWrapper = event.target.closest('.quick-add-collapsed-wrapper');
      var priceElement = collapsedWrapper ? collapsedWrapper.querySelector('.quick-add-price .product-price') : null;
      if (priceElement) {
        priceElement.textContent = variantPrice;
      }
    }
  });

});

$(document).off('click.roamAddons', '#addToCartButton').on('click.roamAddons', '#addToCartButton', function(e) {
  e.preventDefault();
  console.log("add extras");
  var itemsToAdd = [];

  $('.quick-add-product.active-product').each(function() {
    var activeVariantId = $(this).find('.quick-add-variant-button.active').data('variant-id');
    if (!activeVariantId) {
      activeVariantId = $(this).data('variant-id');
    }
    var quantityRaw = $(this).find('.quantity-input-pd').val();
    var quantity = parseInt(quantityRaw, 10) || 1;
    console.log("variant id and qty are", activeVariantId, quantity);
    if (activeVariantId && quantity) {
      itemsToAdd.push({
        id: Number(activeVariantId),
        quantity: parseInt(quantity, 10)
      });
    }
  });

  if (typeof window.dispatchRoamAddonsUpdated === 'function') {
    window.dispatchRoamAddonsUpdated();
  }

  if (itemsToAdd.length > 0) {
    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ items: itemsToAdd }),
      success: function(response) {
        console.log('Items added to cart:', response);
        $('button[name="add"]').click();
      },
      error: function(xhr, status, error) {
        console.error('Error adding items to cart:', xhr, status, error);
      }
    });
  } else {
    console.log('No extras selected.');
    $('button[name="add"]').click();
  }
});
